import React from "react";

import "../../../utils/layout.css";
import "../../../utils/constants.css";

const EmailVerfied = () => {
  const publicDir = process.env.PUBLIC_URL;
  const logoImagePath = publicDir + "/assets/images/logo.png";
  const waveImagePath = publicDir + "/assets/images/wave.png";

  return (
    <div className="fullscreen flex-column-start-center">
      <img className="logo-image" src={logoImagePath} />
      <div className='primary-font' style={{ fontSize: 25, padding: 10, textAlign: 'justify', }} >Your email has been verfied. Proceed to the app.</div>
      <img className="wave-image" src={waveImagePath} />
    </div>
  );
};

export default EmailVerfied;
